export default "__VITE_ASSET__664842cb__"